import Actions from '../actions/actions';
import { xRayConfigurationCRUDActions as XRayConfigurationCRUDActions } from '../actions/XRayConfiguration';
import {
  retrieved,
  retrievedAll,
  setBusy,
  setUnBusy,
  update,
} from './common/commonReducers';
import {
  XrayConfigurationPayload,
  XrayConfigurationState,
} from '../interfaces/xrayConfiguration';

interface ActionType {
  type: string;
  entity: XrayConfigurationPayload;
  payload?: any;
}

const initialState: XrayConfigurationState = {
  entities: [],
  busy: false,
};

// eslint-disable-next-line default-param-last
export const xrayConfigurations = (
  state = initialState,
  action: ActionType,
) => {
  switch (action.type) {
    case XRayConfigurationCRUDActions.busyAction:
      return setBusy(state);
    case XRayConfigurationCRUDActions.retrievedAllAction:
      return retrievedAll(state, action, false, 'facebookPageId');
    case XRayConfigurationCRUDActions.updateAction:
    case XRayConfigurationCRUDActions.updateLocalAction:
      return update(state, action, 'facebookPageId');
    case XRayConfigurationCRUDActions.retrievedAction:
      return retrieved(state, action);
    case XRayConfigurationCRUDActions.unbusyAction:
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
